var project = {
  package_item: (parent_id = null) => {
    return {
      pid: $('#pid').val(),
      parent_id: parent_id,
      content: $("#content").val(),
      quantity: $("#quantity").val(),
      unit_price: $("#unit_price").val(),
      cost: $("#cost").val(),
      optional: ($("#optional").prop("checked") ? 1 : 0),
    };
  },
  store_item: () => {
    $.ajax({
        type: "POST",
        url: '/project/item/store',
        data: package_item(),
      })
      .done(function(data) { table.ajax.reload();
        toastr.success(`教練:${data.name_cht}已刪除`); })
      .fail(function(jqXHR, textStatus, errorThrown) { console.log(jqXHR);
        toastr.error(jqXHR.responseJSON.message); })
  },
  update_item: () => {
    $.ajax({
        type: "POST",
        url: '/project/item/update',
        data: package_item($('#parent_id').val()),
      })
      .done(function(data) { table.ajax.reload();
        toastr.success(`教練:${data.name_cht}已刪除`); })
      .fail(function(jqXHR, textStatus, errorThrown) { console.log(jqXHR);
        toastr.error(jqXHR.responseJSON.message); })
  }

}

module.exports = project

//Update Total and Deposit
function UpdateTotal() {
  $("#AllTotal").val($("#Total").val() - $("#Discount").val())
  if ($("#Deposit").val() == "") {
    if ($("#AllTotal").val() < 10000) {
      $("#Deposit").val(0);
      $("#FirstPayment").val(0);
      $("#FinalPayment").val($("#AllTotal").val());
    } else {
      $("#Deposit").val($("#AllTotal").val() * 0.3);
      $("#FirstPayment").val($("#AllTotal").val() * 0.3);
      $("#FinalPayment").val($("#AllTotal").val() * 0.4);
    }
  }
}

//Submit Project to Database
function SubmitProject() {
  $.ajax({
    url: '/ajax/project.php',
    type: 'POST',
    data: {
      SubmitProject: {
        PID: $('#PID').val(),
        CustomerID: $("#CustomerID").val(),
        Description: $("#Title").val(),
        ReceiveDate: $("#CreateDate").val(),
        CompleteDate: $("#CompleteDate").val(),
        Cancel: ($("#ProjectStatus input").prop("checked") ? 1 : 0),
        Note: $('#Remark').val()
      }
    },
    success: function(data) {
      if (data == 1) {
        $("#SaveButton").before("<div class=\"alert alert-success\" role=\"alert\">Update Success!</div>")
      } else if (data == 0) {
        $("#SaveButton").before("<div class=\"alert alert-danger\" role=\"alert\">Update Fail!</div>")
      }
      setTimeout(function() {
        $(".alert").alert("close")
      }, 3000);
      CreateProjectList($('#PID').val());
    }
  });
}

//Read Request Item from Database
function readRequest(PID) {
  $.ajax({
    url: '/ajax/project.php',
    type: 'POST',
    data: {
      ReadRequest: PID
    },
    success: function(data) {
      $('#requirmentContainer').empty();
      data = $.parseJSON(data);
      if (data.length > 0) {
        $.each(data, function(index, item) {
          newRequest("db", item = item)
        });
        defer.resolve();
      }
    }
  });
  return false;
}

//Create New Request Item
function newRequest(item = "", data = "") {
  function createDropdown(data) {
    dropitem = [
      "<span class=\"dropdown-item dropdown-item-light\">Parent ID: " + data['ParentID'] + "</span>",
      "<span class=\"dropdown-item dropdown-item-light\">ID: " + data['id'] + "</span>",
      "<span class=\"dropdown-item dropdown-item-light optional\" data-optional=\"" + data['optional'] + "\">Is Optional: " + (data['optional'] ? "Yes" : "No") + "</span>",
      "<span class=\"dropdown-item dropdown-item-light\"><i class=\"fas fa-stopwatch\"></i> <span class=\"Req_time\">" + time + "</span>小時</span>",
      "<button class='dropdown-item dropdown-item-light btn' onclick='removeRequest($(this));'><i class=\"far fa-trash-alt\"></i> 刪除</button>",
    ]
    return "<button type=\"button\" class=\"btn btn-" + category + border + " dropdown-toggle dropdown-toggle-split\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"sr-only\">Toggle Dropdown</span></button><div class=\"dropdown-menu\">" + dropitem.join("") + "</div>";
  }

  time = (item == "db" ? (data['EstimateTime'] === null ? "0" : data['EstimateTime']) : ($("#Req_time").val() == "" ? "0" : $("#Req_time").val()));
  cost = (item == "db" ? (data['cost'] === null ? "0" : data['cost']) : ($("#cost").val() == "" ? "0" : $("#cost").val()));
  content = (item == "db" ? data['Content'] : $("#Required").val());
  optional = (item == "db" ? data['optional'] : ($("#optional").prop("checked") ? 1 : 0));
  categoryNum = (item == "db" ? data['Type'] : $("#Req_category option:selected").val());
  switch (true) {
    case categoryNum == 0:
      category = "light"
      border = " border-light"
      btn = " btn-light"
      break;
    case categoryNum == 1:
      category = "warning"
      border = " border-warning"
      btn = " btn-warning"
      break;
    case categoryNum == 2:
      category = "primary"
      border = " border-primary"
      btn = " btn-primary"
      break;
  }
  dropdown = createDropdown(data);
  costSpan = "<div class=\"input-group-text input-group-text-" + category + "\">$<span class=\"cost\" data-val=\"" + cost + "\">" + (parseInt(cost)).toLocaleString() + "</span></div>";
  editSpan = "<button class=\"Req_change btn" + btn + border + "\" data-editting=\"false\" onclick=\"requestChange($(this))\"><i class=\"fas fa-edit\"></i></button>";
  qgrp = "<div class=\"input-group-text input-group-text-" + category + "\"><input class=\"qgrp\" type=\"checkbox\"></div>";
  btngrp = "<button class='btn" + btn + border + "' onclick='newRequest($(this));'>下層</button>";
  itemNospan = "<span class=\"input-group-text ItemNo input-group-text-" + category + "\"></span>";
  rowPrepend = "<div class=\"input-group-prepend\">" + itemNospan + "</div>";
  rowAppend = "<div class=\"input-group-append dropleft\">" + costSpan + qgrp + btngrp + editSpan + dropdown + "</div>";
  // rowMain = "<textarea class=\"form-control disabled Req_Content\" rows=\"1\" disabled>" + content + "</textarea>";
  rowMain = "<div class=\"border form-control Req_Content" + border + " bg-" + category + " p-1 p-lg-2\" style=\"height: auto;\">" + content + "</div>";
  rowHidden1 = "<input type=\"hidden\" class=\"Req_category\" value=\"" + categoryNum + "\"/>";
  rowHidden2 = (item == "db" ? "<input type=\"hidden\" class=\"parentid\" value=\"" + data['ParentID'] + "\" />" : "");
  rowHidden3 = (item == "db" ? "<input type=\"hidden\" class=\"id\" value=\"" + data['id'] + "\" />" : "");
  if (item != "db") {
    ParentID = (item == "" ? 0 : item.parentsUntil(".Req_row").parent().find(".id").val());
    $.ajax({
      url: '/ajax/project.php',
      type: 'POST',
      data: {
        table: "P_Requirement",
        data_array: {
          PID: $('#PID').val(),
          ParentID: ParentID,
          EstimateTime: time,
          Content: content,
          cost: cost,
          Type: categoryNum,
          optional: optional
        }
      },
      success: function(itemID) {
        console.log(itemID)
        data = [];
        data['ParentID'] = ParentID;
        data['id'] = itemID;
        rowHidden2 = "<input type=\"hidden\" class=\"parentid\" value=\"" + data['ParentID'] + "\" />";
        rowHidden3 = "<input type=\"hidden\" class=\"id\" value=\"" + data['id'] + "\" />";
        rowAppend = "<div class=\"input-group-append dropleft\">" + costSpan + qgrp + btngrp + editSpan + createDropdown(data) + "</div>";
        row = "<div class=\"Req_row input-group mb-1\">" + rowPrepend + rowMain + rowHidden1 + rowHidden2 + rowHidden3 + rowAppend + "</div>"
        console.log([data, item, row])
        appendROW(data, item, row)
      }
    });
  } else {
    row = "<div class=\"Req_row input-group mb-1\">" + rowPrepend + rowMain + rowHidden1 + rowHidden2 + rowHidden3 + rowAppend + "</div>"
    appendROW(data, item, row)
  }
  $("#Required").val("")
  $("#Req_time").val("")
  $("#optional").prop("checked", 0)
  $("#cost").val("")
    // $("#Req_category option:eq(0)").prop("selected",true)
}

//Append ROW
function appendROW(data, item, row) {
  li = "<li></li>";
  ul = "<ul></ul>";
  if (item == "") {
    $('#requirmentContainer').append(
      $(li).append(row)
    );
  } else if (item == "db") {
    if (data['ParentID'] == 0) {
      $('#requirmentContainer').append(
        $(li).append(row)
      );
    } else {
      req_row = $('#requirmentContainer').find(".id[value=\"" + data['ParentID'] + "\"]").parent();
      if (req_row.parent().find("ul").length > 0) {
        req_row.parent().find("ul:eq(0)").append(
          $(li).append(row)
        );
      } else {
        req_row.parent().append(
          $(ul).append(
            $(li).append(row)
          )
        );
      }
    }
  } else {
    req_row = item.parentsUntil(".Req_row").parent()
    if (req_row.parent().find("ul").length > 0) {
      req_row.parent().find("ul:eq(0)").append(
        $(li).append(row)
      );
    } else {
      req_row.parent().append(
        $(ul).append(
          $(li).append(row)
        )
      );
    }
  }
  sortable();
}

//Remove Request Item
function removeRequest(item) {
  remove = confirm("確認移除?");
  if (remove && item.parentsUntil(".Req_row").parent().parent().find("ul").length == 0) {
    id = item.parentsUntil(".Req_row").parent().find(".id").val();
    $.ajax({
      url: '/ajax/project.php',
      type: 'POST',
      data: {
        table: "P_Requirement",
        removeID: id
      },
      success: function(data) {
        if (data == 1) {
          item.parentsUntil(".Req_row").parent().parent().remove();
          sortable();
        }
      }
    });
  }
}

//Make Request Item Sortable
function sortable() {
  var group = $('#requirmentContainer').sortable({
    group: 'serialization',
    delay: 100,
    onDrop: function($item, container, _super) {
      var data = group.sortable("serialize").get();
      jsonString = JSON.stringify(data, null, ' ');
      _super($item, container);
      updateItemNo();
    },
  });
  updateItemNo();
  autogrow();
}

//Request Change on Request Item
function requestChange(item) {
  if (item.data("editting")) {
    item.html('<i class=\"fas fa-edit\"></i>').data("editting", false).closest('.Req_row').removeClass('Req_active');
  } else {
    $(".Req_change").html('<i class=\"fas fa-edit\"></i>').data("editting", false);
    $(".Req_row").removeClass('Req_active');
    item.data("editting", true).text("取消");
    item.closest('.Req_row').addClass("Req_active");
    $("#Required").val(item.closest('.Req_active').find(".Req_Content").html())
    $("#Req_time").val(item.closest('.Req_active').find(".Req_time").text())
    $("#cost").val(parseInt(item.closest('.Req_active').find(".cost").data("val")))
    $("#optional").prop("checked", item.closest('.Req_active').find('.optional').data("optional"))
    $("#Req_category option[value=\"" + item.closest('.input-group.mb-1').find(".Req_category").val() + "\"]").prop('selected', true);
    $("#Required").focus()
  }
}

//Make Change on Request Item
function confirmChange() {
  item = $(".Req_row.Req_active");
  if (item.length >= 1) {
    $.ajax({
      url: '/ajax/project.php',
      type: 'POST',
      data: {
        ChangeRequest: {
          id: item.find('.id').val(),
          PID: $('#PID').val(),
          Content: $("#Required").val(),
          ParentID: item.find('.parentid').val(),
          EstimateTime: $("#Req_time").val(),
          optional: $("#optional").prop("checked") ? 1 : 0,
          cost: $("#cost").val(),
          Type: $("#Req_category").val(),
        }
      },
      success: function(data) {}
    });
    item.removeClass("Req_active");
    item.find(".Req_change").html('<i class=\"fas fa-edit\"></i>').data("editting", false);
    item.find(".Req_Content").html($("#Required").val())
    item.find(".Req_time").text($("#Req_time").val())
    item.find(".optional").data("optional", $("#optional").prop("checked")).text("Is optional: " + ($("#optional").prop("checked") ? "Yes" : "No"))
    item.find(".cost").text(parseFloat($("#cost").val()).toLocaleString()).data("val", parseFloat($("#cost").val()))
    item.find(".Req_category").val($("#Req_category option:selected").val())
    item.find(".ItemNo").removeClass(
      function(index, className) {
        return (className.match(/(^|\s)bg-\S+/g) || []).join(' ');
      }
    )
    switch (true) {
      case $("#Req_category option:selected").val() == 2:
        category = "bg-primary"
        break;
      case $("#Req_category option:selected").val() == 0:
        category = "bg-light"
        break;
      case $("#Req_category option:selected").val() == 1:
        category = "bg-danger"
        break;
    }
    item.find(".ItemNo").addClass(category)
    $("#Required").val("")
    $("#Req_time").val("")
    $("#cost").val("")
    $("#optional").prop("checked", 0)
    $("#Req_category option:eq(0)").prop("selected", true)
  }
  autogrow()
}

//Calculate latest Request Item Number after sorting or whenever need
function updateItemNo() {
  $('#requirmentContainer div.input-group.mb-1').each(function(i, v) {
    $(v).find('.ItemNo').text(($(v).parent().parent().prop("id") == "requirmentContainer" ? "" : $(v).parentsUntil("ul").parent().parent().find("div.input-group.mb-1 .ItemNo:eq(0)").text() + ".") + ($(v).parent().index() + 1))
  })
  $('#requirmentContainer ul').each(function(i, v) {
    if ($(v).find("li").length == 0) {
      $(v).remove()
    }
  })
}

//Read Project from Database
function ReadProject(item) {
  var PID = item.data("id")
  workingPID = PID
  LoadingScreen("on");
  $.ajax({
    url: '/ajax/project.php',
    type: 'POST',
    data: {
      ReadProject: PID
    },
    success: function(data) {
      data = $.parseJSON(data);
      console.log(data)
      if (data['PID'] != null) {
        $('#PID').attr('readonly', true)
        $("#ProjectList .list-group-item").removeClass('active list-group-item-info workingItem')
        $("#ProjectList [data-id=" + data['PID'] + "]").addClass('active')
        $('#PID').val(PID)
        $("#Title").val(data['Description']);
        $("#CreateDate").val(data['ReceiveDate'] === null ? "" : data['ReceiveDate'].split(" ")[0]);
        $("#CompleteDate").val(data['CompleteDate'] === null ? "" : data['CompleteDate'].split(" ")[0]);
        $("#ProjectStatus input").prop("checked", data['Cancel']);
        $("#CustomerID").val(data['CustomerID']);
        $('#Remark').val(data['Note']);
        CreateQuotationRow(data['Quotation'])
        CreateInvoiceRow(data['Invoice']);
        ReadCustomer(data['CustomerID']);
        // readRequest(PID);
        var wait = function(defer) {
          readRequest(PID)
          return defer;
        };
        $.when(wait(defer))
          .done(function() {
            if ($("#sortable_btn").is(":visible")) {
              toggleSortable($("#sortable_btn"), true);
            }
            defer = $.Deferred();
          })
          .fail(function() {
            console.log("failed");
            defer = $.Deferred();
          });
        LoadingScreen("off");
      }
    }
  });
  return false;
}

//Read Quotation from Database
function ReadQuotation() {
  $.ajax({
    url: '/ajax/project.php',
    type: 'POST',
    data: {
      ReadQuotation: workingPID
    },
    success: function(data) {
      data = $.parseJSON(data);
      CreateQuotationRow(data['Quotation']);
    }
  });
}

//Read Invoice from Database
function ReadInvoice() {
  $.ajax({
    url: '/ajax/project.php',
    type: 'POST',
    data: {
      ReadInvoice: workingPID
    },
    success: function(data) {
      data = $.parseJSON(data);
      CreateInvoiceRow(data['Invoice']);
    }
  });
}

//Create Quotation Row
function CreateQuotationRow(data) {
  $('#QuotationContainer').DataTable().clear().draw();
  $.each(data, function(index, val) {
    $("#QuotationContainer").DataTable().row.add(
      [val.QID, val.CreateDate, "<span contentEditable>" + (val.DeliveryDate == null ? "-" : val.DeliveryDate) + "</span>", "<span contentEditable>" + (val.ReplyDate == null ? "-" : val.ReplyDate) + "</span>", "<a target=\"_blank\" class=\"btn btn-block btn-success\" href=\"quotation.php?QID=" + val.QID + "\">打開</a>", "<button class=\"btn btn-block btn-primary\" onclick=\"SubmitInvoice('" + val.id + "')\">建立</button>"]
    ).draw(false);
    // $('#QuotationContainer').append("<div class=\"col-8 mt-1\"><a class=\"btn btn-block btn-success\" href=\"quotation.php?QID="+val.QID+"\">"+val.QID+" - "+val.CreateDate+"</a></div><div class=\"col-4 mt-1\"><button class=\"btn btn-block btn-primary\" onclick=\"SubmitInvoice('"+val.id+"')\">產生發票</button></div>")
  });
}

//Create Invoice Row
function CreateInvoiceRow(data) {
  // $('#InvoiceContainer').empty()
  $('#InvoiceContainer').DataTable().clear().draw();
  $.each(data, function(index, val) {
    $("#InvoiceContainer").DataTable().row.add(
      ["I" + val.IID, val.CreateDate, "<span contentEditable>" + (val.DeliveryDate == null ? "-" : val.DeliveryDate) + "</span>", "<span contentEditable>" + (val.ReplyDate == null ? "-" : val.ReplyDate) + "</span>", "<a target=\"_blank\" class=\"btn btn-block btn-success\" href=\"invoice.php?IID=" + val.IID + "\">打開</a>", "<a target=\"_blank\" class=\"btn btn-block btn-success\" href=\"receipt.php?RID=" + val.IID + "\">打開</a>", "<form class=\"mb-0\" method=\"post\" action=\"/account/income.php\"><button class=\"btn btn-block btn-success\" type=\"submit\">增加</button><input type=\"hidden\" name=\"id\" value=\"" + val.id + "\"></form>"]
    ).draw(false);
  });
}

//Read Customer Info from Database
function ReadCustomer(id) {
  $.ajax({
    url: '/ajax/project.php',
    type: 'POST',
    data: {
      ReadCustomer: id
    },
    success: function(data) {
      data = $.parseJSON(data)[0];
      if (data['CustomerID'] != null) {
        $('#FirstName').val(data['CustomerFirstName'])
        $('#LastName').val(data['CustomerLastName'])
        $("#CompanyName").val(data['CustomerCompanyName']);
        $("#CustomerCompanyAddress").val((data['CustomerCompanyAddress1'] + "\n" + data['CustomerCompanyAddress2'] + "\n" + data['CustomerCompanyAddress3'] + "\n" + data['CustomerCompanyAddress4']).replace(/^\s*\n/gm, "").replace(/\n$/, ""));
        $("#Phone").val(data['CustomerPhone']);
        $("#Fax").val(data['CustomerFax']);
        $("#Email").val(data['CustomerEmail']);
        autogrow()
      }
    }
  });
  return false;
}

//toggle Loading Screen
function LoadingScreen(status) {
  if (status == "on") {
    $("body").append("<div class=\"loading\"></div>")
  } else {
    $(".loading").remove();
  }
}

//Turn on or of Sortable function
function toggleSortable(item, control = null) {
  if ((item.hasClass("active") && control == null) || control == true) {
    item.removeClass('active').text("開啟排序功能")
    $("#requirmentContainer").sortable("disable")
  } else if (!(item.hasClass("active") && control == null) || control == false) {
    item.addClass('active').text("關閉排序功能")
    $("#requirmentContainer").sortable("enable")
  }
}

//Automatically resize textarea
function autogrow() {
  $("textarea").each(function(index, textarea) {
    $(textarea).css('height', '0px');
    var adjustedHeight = textarea.clientHeight;
    adjustedHeight = Math.max(textarea.scrollHeight, adjustedHeight);
    $(textarea).css('height', (adjustedHeight + 5) + 'px');
  });
}

//toggle Request row
function toggleRequestRow(floor, item) {
  item.toggleClass("active")
  child = ">ul>li";
  $("#requirmentContainer>li" + child.repeat(floor - 1)).toggle(item.hasClass('active'))
}

//Create Quotation
function SubmitQuotation() {
  $.ajax({
    url: '/ajax/project.php',
    type: 'POST',
    data: {
      SubmitQuotation: {
        PID: $('#PID').val(),
        Content: QuotationItem(),
        Status: 0,
        Deposit: 0,
        FirstPayment: 0,
        SecondPayment: $("#SecondPayment").val(),
        Discount: $("#Discount").val(),
        Price: 0 + 0 + $("#SecondPayment").val()
      }
    },
    success: function(data) {
      if (data == 1) {
        $("#QuotationSave").before("<div class=\"alert alert-success\" role=\"alert\">Quotation Submit!</div>")
      } else if (data == 0) {
        $("#QuotationSave").before("<div class=\"alert alert-danger\" role=\"alert\">Quotation Submit Fail!</div>")
      }
      setTimeout(function() {
        $(".alert").alert("close")
      }, 3000);
      ReadQuotation()
    },
    error: function(jqXHR, textStatus, errorThrown) {
      console.log(textStatus)
    }
  });
}

//Create Invoice
function SubmitInvoice(id) {
  $.ajax({
    url: '/ajax/project.php',
    type: 'POST',
    data: {
      SubmitInvoice: {
        id: id
      }
    },
    success: function(data) {
      console.log(data)
      if (data == 1) {
        $("#QuotationContainer").before("<div class=\"alert alert-success\" role=\"alert\">Invoice Created!</div>")
      } else if (data == 0) {
        $("#QuotationContainer").before("<div class=\"alert alert-danger\" role=\"alert\">Invoice Create Fail!</div>")
      }
      setTimeout(function() {
        $(".alert").alert("close")
      }, 3000);
      ReadInvoice()
    },
    error: function(jqXHR, textStatus, errorThrown) {
      console.log(textStatus)
    }
  });
}

//Store Working Tab
function StorWorkingTab(item) {
  setCookie('WorkingTab', item.data('target'));
}

function pageRotationEvent() {
  toggleSortable($("#sortable_btn"), $("#sortable_btn").is(":visible"));
}

//Calculate Total from subtotal
function calculateTotal() {
  total = 0;
  $(".cost").each(function(i, v) {
    total += parseFloat($(v).data("val"))
  });
  $('#SecondPayment').val(total);
}

var edit_item = (hash) => {
  $.ajax({
    type: "POST",
    url: `/project/item/edit/${hash}`,
data : {
  "content": $(`#${hash}`).val(),
  "cost": $(`#${hash}_cost`).val()
},

    dataType: "dataType",
  })
  .done((data) => { toastr.success(data.message); });
}